// Returns the current viewport width in pixels, with fallbacks for older browsers that don't support `window.innerWidth`.
export function getViewportWidth () {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}

// Default breakpoint matches the EPG search widget's desktop/mobile switch (e.g. whether the filter panel
// stays open, or the mobile dialog overlay classes get applied).
export function isDesktopViewport (breakpoint = 840) {
  return getViewportWidth() >= breakpoint
}
